

import { Label, TextArea } from '../components/layout/Form'
import {MdEmail,MdTitle,BsPersonFill} from "../components/icons"
import { Products_Details } from './Products_Details.1'
export default Products_Details